import imagemcnm from 'imagens/logo-cnm-letra-azul.png'
import logocnm from 'imagens/logo-cnm-rodape.png'
import { Grid } from '@material-ui/core'
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
const RedesSociaisbranco = () => {
    return (
        <>
            <Grid>
                <Grid>
                    <img src={logocnm}  alt="" style={{ width: '100%' }} />
                </Grid>
                <Grid>
                    <a href='https://www.facebook.com/portalcnm' target='_blank' rel="noopener noreferrer"><FacebookOutlinedIcon style={{ color: 'var(--branco)', marginLeft: '0.5em' }} /></a>
                    <a href='https://twitter.com/i/flow/login?redirect_after_login=%2Fportalcnm' target='_blank' rel="noopener noreferrer" ><XIcon style={{ color: 'var(--branco)', marginLeft: '0.5em' }} /></a>
                    <a href='https://www.instagram.com/portalcnm/' target='_blank' rel="noopener noreferrer"><InstagramIcon style={{ color: 'var(--branco)', marginLeft: '0.5em' }} /></a>
                    <a href='https://www.youtube.com/user/tvportalcnm' target='_blank' rel="noopener noreferrer"><YouTubeIcon style={{ color: 'var(--branco)', marginLeft: '0.5em' }} /></a>
                </Grid>
            </Grid>
        </>
    )
}

const RedesSociaisLaranja = () => {
    return (
        <>
            <Grid container style={{ justifyContent: 'center' }}>
                <img src={imagemcnm} style={{ width: '90%' }}  alt=""  />
                <Grid>
                    <a href='https://www.facebook.com/portalcnm' target='_blank' rel="noopener noreferrer"><FacebookOutlinedIcon style={{ color: 'var(--azul-vivido)', fontSize: '2em' }} /></a>
                    <a href='https://twitter.com/i/flow/login?redirect_after_login=%2Fportalcnm' target='_blank' rel="noopener noreferrer"><XIcon style={{ color: 'var(--azul-vivido)', fontSize: '2em' }} /></a>
                    <a href='https://www.instagram.com/portalcnm/' target='_blank' rel="noopener noreferrer"><InstagramIcon style={{ color: 'var(--azul-vivido)', fontSize: '2em' }} /></a>
                    <a href='https://www.youtube.com/user/tvportalcnm' target='_blank' rel="noopener noreferrer"><YouTubeIcon style={{ color: 'var(--azul-vivido)', fontSize: '2em' }} /></a>
                </Grid>
            </Grid>
        </>
    )
}


export { RedesSociaisbranco, RedesSociaisLaranja };
